<template>
  <div class="row">
    <div class="col-12">
      <card>
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <div class="row">
              <select-component
                modelName="farm_id"
                :rowClass="
                  dataFilter.by_sel === 'year'
                    ? `col-12 col-sm-6 col-md-5 col-lg-4 col-xl-3`
                    : `col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3`
                "
                :isMultiple="false"
                :dataOptions="farms"
                :requireClass="`required-farm`"
                :labelSelect="`${$t('common_words.farm')}: *`"
                :initialSelection="dataFilter.farm_id"
                @onChange="handleChangeSelected"
              />
              <select-component
                modelName="by_sel"
                :rowClass="
                  dataFilter.by_sel === 'year'
                    ? `col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2`
                    : `col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2`
                "
                :isMultiple="false"
                :dataOptions="bySelOptions"
                :requireClass="`required-bySel`"
                :labelSelect="`${$t('common_words.analyze_by')} *`"
                :initialSelection="dataFilter.by_sel"
                @onChange="handleChangeSelected"
              />
              <div
                :class="
                  dataFilter.by_sel === 'year'
                    ? `col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2`
                    : `col-12 col-sm-6 col-md-4 col-lg-2 col-xl-2`
                "
                v-if="dataFilter.by_sel"
              >
                <label>{{ $t('common_words.year') }}: *</label>
                <br />
                <el-date-picker
                  name="year"
                  type="year"
                  class="shadow-sm required-year"
                  v-model="dataFilter.year_sel"
                  value-format="yyyy"
                  :placeholder="`${$t('common_words.select2')}...`"
                  @change="handleChangeYear"
                />
              </div>
              <template v-if="dataFilter.by_sel === 'week'">
                <select-component
                  modelName="init_week"
                  :rowClass="`col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2`"
                  :isMultiple="false"
                  :dataOptions="optionWeeks"
                  :requireClass="`required-initWeek`"
                  :labelSelect="`${$t('common_words.initial_week')} *`"
                  :initialSelection="dataFilter.init_week"
                  :disabled="!dataFilter.year_sel"
                  @onChange="handleChangeSelected"
                />
                <select-component
                  modelName="end_week"
                  :rowClass="`col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2`"
                  :isMultiple="false"
                  :dataOptions="optionsEndWeek"
                  :requireClass="`required-endWeek`"
                  :labelSelect="`${$t('common_words.end_week2')} *`"
                  :initialSelection="dataFilter.end_week"
                  :disabled="!dataFilter.year_sel"
                  @onChange="handleChangeSelected"
                />
              </template>
              <div class="col-12 col-md-4 col-xl-2">
                <label class="label-primary" style="color: transparent">{{
                  $t('common_words.filter')
                }}</label
                ><br />
                <l-button
                  wide
                  type="info"
                  class="btn-filter"
                  @click="handleFilter"
                >
                  {{ $t('common_words.filter') }}
                </l-button>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </card>
      <div v-if="isIndex()">
        <card
          class="custom-shadow-card-header"
          :title="$t('labor.report_agricultural_practices_control')"
          v-show="this.tableData && this.tableData.length > 0"
        >
          <el-container>
            <el-main :style="'paddingLeft: 0 !important; overflow: hidden;'">
              <card-header
                class="p-0"
                :propPagination="pagination"
                @searchedQuery="searchedQuery"
              >
                <template slot="between">
                  <div class="align-center-cell-flex">
                    <el-checkbox
                      label="Solo Programado"
                      :value="onlyScheduled"
                      :disabled="onlyExecuted"
                      @change="handleCheckboxChange('onlyScheduled', $event)"
                    />
                    <el-checkbox
                      label="Solo Ejecutado"
                      :value="onlyExecuted"
                      :disabled="onlyScheduled"
                      @change="handleCheckboxChange('onlyExecuted', $event)"
                    />
                  </div>
                </template>
              </card-header>

              <div class="legend-container">
                <div class="legend-item">
                  <strong>P</strong>: {{ $t('labor.scheduled') }}
                </div>
                <div class="legend-item">
                  <strong>E</strong>: {{ $t('labor.executed') }}
                </div>
                <div class="legend-item">
                  <strong>%</strong>: {{ $t('labor.completion_percentage') }}
                </div>
              </div>

              <el-table
                ref="tablaPrincipal"
                style="width: 100%"
                :max-height="tableHeight"
                :data="queriedData"
                :default-sort="{ prop: 'activity', order: 'ascending' }"
                :cell-style="handlecellstyle"
              >
                <el-table-column type="expand" min-width="50" :fixed="true">
                  <template slot-scope="props">
                    <div class="expand-content">
                      <table>
                        <tbody>
                          <tr
                            v-for="(detailedLot, lot) in props.row
                              .detailed_lots"
                            :key="lot"
                          >
                            <td
                              :style="`width: ${expandColumnWidth}px; border: none !important`"
                            ></td>
                            <td
                              :style="`width: ${activityColumnWidth}px; border: none !important`"
                            ></td>
                            <td
                              :style="`
                                width: ${lotColumnWidth}px;
                                font-weight: bold;
                                text-align: left;
                              `"
                            >
                              {{ lot }}
                            </td>
                            <template v-for="data in tableColumns.slice(2)">
                              <td
                                v-if="
                                  (!onlyScheduled && !onlyExecuted) ||
                                  onlyScheduled
                                "
                                :key="data.label + '-P'"
                                :style="`width: ${programedColumnWidth}px`"
                              >
                                {{
                                  getWeekData(
                                    data.label,
                                    detailedLot,
                                    'planned_quantity'
                                  )
                                }}
                              </td>
                              <td
                                v-if="
                                  (!onlyScheduled && !onlyExecuted) ||
                                  onlyExecuted
                                "
                                :key="data.label + '-E'"
                                :style="`width: ${executedColumnWidth}px`"
                              >
                                {{
                                  getWeekData(
                                    data.label,
                                    detailedLot,
                                    'executed_quantity'
                                  )
                                }}
                              </td>
                              <td
                                v-if="!onlyScheduled && !onlyExecuted"
                                :key="data.label + '-%'"
                                :style="`width: ${complianceColumnWidth}px`"
                                :class="
                                  getCompletionRateClass(
                                    data.label,
                                    detailedLot
                                  )
                                "
                              >
                                {{
                                  getWeekData(
                                    data.label,
                                    detailedLot,
                                    'completion_rate'
                                  )
                                }}
                              </td>
                            </template>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </template>
                </el-table-column>

                <template v-for="column in tableColumns">
                  <el-table-column
                    v-if="!column.children && showColumn(column.show)"
                    :key="`col-${column.label}`"
                    :prop="column.prop"
                    :label="column.label"
                    :min-width="column.minWidth"
                    :align="column.align"
                    :sortable="column.sortable"
                    :fixed="column.fixed"
                    :formatter="getFormatter(column.formatter)"
                  />
                  <el-table-column
                    v-else
                    :key="`group-${column.label}`"
                    :label="column.label"
                    align="center"
                  >
                    <template v-for="subColumn in column.children">
                      <template v-if="isValidFormatter(subColumn.formatter)">
                        <el-table-column
                          v-if="showColumn(subColumn.show)"
                          :prop="subColumn.prop"
                          :label="subColumn.label"
                          :min-width="subColumn.minWidth"
                          :align="subColumn.align"
                        >
                          <template
                            slot-scope="props"
                            v-if="isValidFormatter(subColumn.formatter)"
                          >
                            <div
                              v-if="subColumn.formatter"
                              :is="subColumn.formatter"
                              :row="props.row"
                              :column="subColumn.prop"
                            ></div>
                            <template v-else>
                              {{ getProperty(props.row, subColumn.prop) }}
                            </template>
                          </template>
                        </el-table-column>
                      </template>
                      <template v-else>
                        <el-table-column
                          v-if="showColumn(subColumn.show)"
                          :prop="subColumn.prop"
                          :label="subColumn.label"
                          :min-width="subColumn.minWidth"
                          :align="subColumn.align"
                        />
                      </template>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
              <card-footer :propPagination="pagination" ref="cardfooter" />
              <div class="align-center-cell-flex">
                <button
                  class="btn custom-btn-success custom-shadow-btn"
                  @click="exportToExcel"
                >
                  <em class="fa fa-file-excel-o"></em>
                  {{ $t('common_words.export_to_excel') }}
                </button>
              </div>
            </el-main>
          </el-container>
        </card>
      </div>
      <not-index-permissions v-else />
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util.js';
import { MixinExport } from 'src/mixins/mixin-export';
import configTable from './cpaReportTable';
import i18n from 'src/i18n';
import mixinDatePicker from 'src/util/mixinDatePicker';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';

export default {
  computed: {
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    reportTypes() {
      return [
        { id: 'detailed', name: i18n.t('common_words.detailed') },
        { id: 'consolidated', name: i18n.t('common_words.consolidated') },
      ];
    },
    bySelOptions() {
      return [
        { id: 'year', name: i18n.t('common_words.year') },
        { id: 'week', name: i18n.t('common_words.week') },
      ];
    },
  },

  data() {
    return {
      activeName: 'filter',
      searchQuery: '',
      valueCollapse: null,
      pagination: {},
      tableData: [],
      tableColumns: [],
      farms: [],
      weeks: [],
      optionWeeks: [],
      rawData: [],
      optionsEndWeek: [],
      farmSelected: null,
      onlyScheduled: false,
      onlyExecuted: false,
      dataFilter: {
        by_sel: 'year',
        end_week: null,
        farm_id: null,
        init_week: null,
        year_sel: moment().format('YYYY'),
      },
      activityColumnWidth: 0,
      complianceColumnWidth: 0,
      executedColumnWidth: 0,
      expandColumnWidth: 0,
      lotColumnWidth: 0,
      programedColumnWidth: 0,
      tableHeight: window.innerHeight * 0.9, // 90% de la pantalla
    };
  },

  mixins: [
    mixinDatePicker,
    MixinExport,
    MixinForm,
    MixinMasters,
    MixinMenu,
    MixinPermissions,
  ],

  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    exportToExcel() {
      const { year_sel, init_week, end_week, by_sel } = this.dataFilter;

      const suffix =
        by_sel === 'year'
          ? `-${year_sel}`
          : by_sel === 'week'
          ? `-${init_week}-${end_week}`
          : '';

      const nameFile = `${i18n.t('labor.cpa_schedule_farm')}${
        this.farmSelected
      }${suffix}.xlsx`;

      const data = {
        route: 'works/cpa/report/excel',
        name_file: nameFile,
        data: this.tableData,
        weeks: this.weeks,
      };
      this.Excel(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    getFormatter(formatter) {
      if (typeof formatter === 'function') return formatter;
      else return null;
    },

    isValidFormatter(formatter) {
      return typeof formatter === 'function' || typeof formatter === 'object';
    },

    getProperty(data, property) {
      return property
        .split('.')
        .reduce(
          (acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined),
          data
        );
    },

    handleCheckboxChange(variable, value) {
      this.showHideLoading(true);
      setTimeout(() => {
        this[variable] = value;
        this.setupTable(this.rawData, this.onlyScheduled, this.onlyExecuted);
        this.showHideLoading();
      }, 150);
    },

    showColumn(show) {
      if (typeof show === 'undefined') return true;
      else if (typeof show !== 'undefined' || show !== null) return show;
    },

    handlecellstyle({ row, column }) {
      if (!column.property || !column.property.includes('.completion_rate')) {
        return '';
      }

      const week = column.property.split('.')[1];

      if (
        !row.weeks ||
        !row.weeks[week] ||
        row.weeks[week].completion_rate === undefined
      ) {
        return '';
      }

      const completionRate = parseFloat(row.weeks[week].completion_rate) || 0;

      return completionRate === 100
        ? 'background-color: #e6fdeb'
        : 'background-color: #fde6e4';
    },

    handleChangeSelected(data) {
      this.$set(this.dataFilter, data.name, data.selects);

      if (data.name === 'init_week') {
        this.dataFilter.end_week = null;

        const selectedIndex = this.optionWeeks.findIndex(
          (week) => week.id === data.selects
        );

        if (selectedIndex !== -1) {
          this.optionsEndWeek = this.optionWeeks.slice(selectedIndex);
        } else {
          this.optionsEndWeek = [];
        }
      } else if (data.name === 'farm_id') {
        const farm = this.farms.find(
          (item) => item.id === this.dataFilter.farm_id
        );
        this.farmSelected = farm && farm.name ? farm.name : null;
        this.tableData = [];
      }
    },

    handleChangeYear(year) {
      this.optionWeeks = this.generateWeekList(year).map((week) => ({
        id: week,
        name: week,
      }));
      this.dataFilter.init_week = null;
      this.dataFilter.end_week = null;
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    handleFilter() {
      this.$validator.validateAll().then((isValid) => {
        if (!isValid) return;

        const requiredFields = [
          { key: 'farm_id', label: 'farm' },
          { key: 'by_sel', label: 'bySel' },
          { key: 'year_sel', label: 'year' },
          ...(this.dataFilter.by_sel === 'week'
            ? [
                { key: 'init_week', label: 'initWeek' },
                { key: 'end_week', label: 'endWeek' },
              ]
            : []),
        ];

        const missingField = requiredFields.find(
          ({ key }) => !isset(this.dataFilter[key])
        );
        if (missingField) {
          return this.validationInputsRequired(missingField.label);
        }

        this.getData();
      });
    },

    getData() {
      this.showHideLoading(true);
      this.tableData = [];
      let data = { ...this.dataFilter, route: 'works/cpa/report' };

      Axios.postMasters(data)
        .then((response) => {
          if (!isset(response.data.data)) {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          } else {
            this.tableData = response.data.data.report;
            this.weeks = response.data.data.weeks;
            this.rawData = response.data.data;
            this.searchFuse(
              this.tableColumns.map((column) => {
                return column.prop;
              })
            );
            this.pagination.perPage = 5;
            this.pagination.currentPage = 1;
            this.searchQuery = '';
            this.setupTable(this.rawData);
          }

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    setupTable(data = null, onlyScheduled = false, onlyExecuted = false) {
      const { Table } = configTable(data, onlyScheduled, onlyExecuted);
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };

      this.$nextTick(() => {
        if (this.$refs.tablaPrincipal) {
          const columns = this.$refs.tablaPrincipal.columns;

          if (columns.length >= 6) {
            this.expandColumnWidth = columns[0].width || 50;
            this.activityColumnWidth =
              columns[1].realWidth || columns[1].minWidth;
            this.lotColumnWidth = columns[2].realWidth || columns[2].minWidth;
            this.programedColumnWidth =
              columns[3].realWidth || columns[3].minWidth;
            this.executedColumnWidth =
              columns[4].realWidth || columns[4].minWidth;
            this.complianceColumnWidth =
              columns[5].realWidth || columns[5].minWidth;
          }
        }
      });
    },

    getWeekData(index, source, key) {
      if (source && source[index] && source[index][key] !== undefined) {
        return source[index][key];
      }

      return '';
    },

    getCompletionRateClass(label, detailedLot) {
      const value = this.getWeekData(label, detailedLot, 'completion_rate');

      const isValid =
        value !== null &&
        value !== undefined &&
        !(typeof value === 'string' && value.trim() === '') &&
        !(typeof value === 'number' && isNaN(value));

      if (!isValid) {
        return 'completion-rate-transparent';
      }

      return value !== 100 ? 'completion-rate-red' : 'completion-rate-green';
    },

    updateTableHeight() {
      this.tableHeight = window.innerHeight * 0.9;
    },
  },

  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      this.setupTable();
      Axios.getMasters('farms/farms/onlyfruit')
        .then((response) => {
          this.farms = response.data.data;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });

      this.handleChangeYear(this.dataFilter.year_sel);
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('works/laborheader');
    window.addEventListener('resize', this.updateTableHeight);
  },

  beforeDestroy() {
    this.deselectedItemOnMenu('works/laborheader');
    window.removeEventListener('resize', this.updateTableHeight);
  },
};
</script>
<style lang="scss" scoped>
.legend-container {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 20px;
  white-space: nowrap;
  margin: 10px 0px;
}

.legend-item {
  font-size: 14px;
}
/* Eliminar padding de la celda expandida completamente */
::v-deep .el-table__expanded-cell {
  padding: 0px !important;
  margin: 0px !important;
  background: transparent !important;
}

/* Ajustar la tabla interna dentro de la celda expandida */
.expand-content {
  width: 100%;
  padding: 0px !important;
  margin: 0px !important;
  background: transparent !important;
}

/* Asegurar que la tabla interna esté alineada correctamente */
.expand-content table {
  width: 100%;
  border-collapse: collapse; /* Quitar espacios entre celdas */
  table-layout: fixed; /* Mantiene alineación */
}

/* Asegurar que las celdas de la tabla interna no tengan espacio extra */
.expand-content td {
  padding: 12px 8px !important;
  margin: 0px !important;
  border: 1px solid gainsboro !important;
  text-align: center;
  vertical-align: middle;
}

/* Asegurar que las filas de la tabla interna no tengan margen extra */
.expand-content tr {
  border: none !important;
  margin: 0px !important;
}

/* Eliminar cualquier borde o separación extra en la tabla expandida */
::v-deep .el-table__expanded-cell[class*='cell'] {
  padding: 0px !important;
  margin: 0px !important;
}

.completion-rate-red {
  background-color: #fde6e4 !important;
}

.completion-rate-green {
  background-color: #e6fdeb !important;
}

.completion-rate-transparent {
  background-color: transparent !important;
  color: inherit !important;
}
</style>
